<template>
  <div class="flex" style="margin: 20px auto 0">
    <div class="swiper" style="width: 65%; height: 450px">
      <el-carousel :interval="3000" type="card" style="height:450px;">
        <el-carousel-item v-for="item in imgList" :key="item.id">
          <div style="width:100%;height:100%;position:relative;" @click="gotoInfo(item)">
            <img class="w-h-100" :src="item.imageFile.url" alt="">
            <div class="font-bottom">
              <div style="width:100%;" class="elipsis-class">
                  <span style="color: white;">[{{item.publishTime}}]</span>
                  <span style="color: white;">[{{item.category.name}}]</span>
                  <span style="color: white;">{{item.title}}</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div style="margin-left: 10px; width: 35%; height: 310px">
      <div class="flex just-between" style="padding: 0 20px">
        <div
          class="flex align-center"
          style="height: 40px; border-bottom: 4px solid #76040b"
        >
          <div style="width: 26px; height: 26px; margin-right: 10px">
            <img class="w-h-100" src="../assets/image/xw.png" alt="" />
          </div>
          <div style="font-size: 20px; color: #76040b" class="font-bold">
            新闻通知
          </div>
        </div>
        <div class="cursor-pointer more" @click="gotoMore">更多>></div>
      </div>
      <div class="border-btm-1">
        <ul style="padding: 0 20px">
          <li v-for="(item, index) in messageList" :key="index" @click="gotoInfo(item)">
            <span
              style="width: 340px; display: inline-block"
              class="elipsis-class"
            >
              <!-- <span style="color: #76040b">[{{ item.category.parent.name || item.category.name }}]</span> -->
              <span class="news-link">{{ item.title }}</span>
            </span>
            <span style="float: right;">{{ item.publishTime }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import "../../node_modules/swiper/dist/css/swiper.css";
import Swiper from "swiper";
export default {
  data() {
    return {
      messageList: [],
      imgList: [],
      titleList: [],
    };
  },
  methods: {
    gotoMore () {
      this.$router.push({
        path: '/list/xwtz'
      })
    },
    gotoInfo (item) {
      localStorage.setItem('sort', "xwtz")
      this.$router.push({
        name: 'noticeDetaile',
        params: {
          id: "xwtz",
          noticeId: item.id
        }
      })
    },
    // swiperStart() {
    //   const swiper = new Swiper(".swiper-container", {
    //     slidesPerView: 1,
    //     autoplay: true,
    //     speed: 1000,
    //     loop: true,
    //     pagination: {
    //       el: ".swiper-pagination",
    //       type: "custom",
    //       clickable: true,
    //       renderCustom: (swiper, current, total) => {
    //         let paginationHtml = " ";
    //         for (let i = 0; i < total; i++) {
    //           // 判断是不是激活焦点，是的话添加active类，不是就只添加基本样式类
    //           if (i === current - 1) {
    //             paginationHtml += `
    //                             <span style="color:#fff;float:left;padding-left:10px;">
    //                                 <span style="color:red;display:inline-block;position: relative;top: -11px;">[${this.imgList[i].category.parent.name || this.imgList[i].category.name}]</span>
    //                                 <span style="display:inline-block;width:260px;white-space: nowrap;text-align:left;text-overflow: ellipsis;overflow: hidden;">${this.imgList[i].title}</span>
    //                             </span>
    //                             <span class="swiper-pagination-customs swiper-pagination-customs-active" ></span>`;
    //           } else {
    //             paginationHtml +=
    //               '<span class="swiper-pagination-customs" ></span>';
    //           }
    //         }
    //         return paginationHtml;
    //       },
    //     },
    //   });
    // },
    getMsgList() {
      const param = {
        pageSize: 9,
        pageNum: 1,
        publishModel: 2
      }
      this.$api.index.getMsgList(param).then((res) => {
        if (res.code === 200) {
          if (res.data.content.length > 0) {
            res.data.content.forEach((item) => {
              item.publishTime = item.publishTime.split("T")[0];
              // item.publishTime = item.publishTime.split('2022-')[1]
            })
          }
          this.messageList = res.data.content;
        }
      });
    },
    getSwiperList() {
      const param = {
        pageSize: 6
      }
      this.$api.index.getImgList(param).then((res) => {
        if (res.code === 200) {
          res.data.forEach((item) => {
            item.publishTime = item.publishTime.split("T")[0];
          })
          this.imgList = res.data
          // setTimeout(() => {
          //   this.swiperStart();
          // }, 1000);
        }
      });
    },
  },
  mounted() {
    this.getMsgList();
    this.getSwiperList();
  },
};
</script>

<style scoped lang='less'>
a.news-link {
  color: #232324;
  margin-left: 3px;
}

a.news-link:hover {
  color: rgb(202, 28, 29);
}
.swiper-wrapper {
  width: 500px;
  height: 310px;
}
.swiper-slide {
  width: 500px;
  height: 310px;
}
/deep/ .swiper-pagination {
  text-align: right;
  background: rgba(0, 0, 0, 0.3);
}
/deep/ .swiper-pagination .swiper-pagination-bullet-active {
  background: red !important;
}
/deep/ .swiper-pagination-bullet {
  background: #fff !important;
  opacity: 1 !important;
}
.swiper-pagination-custom {
  height: 34px;
  line-height: 34px;
  text-align: end !important; //这里设置分页器的位置 放在行的末尾
}
/*自定义分页器的样式*/
/deep/ .swiper-pagination-customs {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 4px;
  margin: 0 3px;
  outline: 0;
  background: #fff;
  box-sizing: border-box;
}
/deep/ .swiper-pagination-customs:last-child {
  margin-right: 16px;
}
/*自定义分页器激活时的样式表现*/
/deep/ .swiper-pagination-customs-active {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: red;
}
/deep/ .swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0;
}
.elipsis-class {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 100%;
}
.more {
  font-size: 14px;
  color: #444;
  height: 40px;
  line-height: 40px;
}
.border-btm-1 {
  border-top: 1px solid #ddd;
}
.border-btm-1 ul li {
  list-style: initial;
  padding: 25px 0 0;
  cursor: pointer;
}
.border-btm-1 ul li::marker {
  color: red;
}
.font-bottom{
  position:absolute;
  bottom:0px;
  width:100%;
  background:rgba(0, 0, 0, .3);
  padding:5px;
  height: 7%;
  display: none;
}
.is-active .font-bottom{
  display: block;
}
/deep/ .el-carousel__container{
  height: 420px;
}
/deep/ .el-carousel__item.is-active{
  width: 73%;
  opacity: 1 !important;
  transform: translateX(100px) scale(1) !important;
}
/deep/ .el-carousel__item--card.is-in-stage{
  opacity: 0.5;
}
</style>
